import { faTag } from '@fortawesome/free-solid-svg-icons';
import { memo, useMemo } from 'react';

import type { Props } from '@/components/TagSelector/types';
import useAPI from '@/hooks/useAPI';
import TagsRepository from '@/repositories/TagsRepository';
import MultiSelect from '@/ui/components/Form/MultiSelect/MultiSelect';

const TagSelector = ({ contentType, name, onChange, value }: Props) => {
  const tagsRepository = TagsRepository();

  const { data: tags } = useAPI({
    queryKey: ['getAvailableTagsForContentType', contentType],
    queryFn: async () => {
      return await tagsRepository.getAvailableTagsForContentType({
        contentType
      });
    }
  });

  const options = useMemo(() => {
    if (tags) {
      return tags.map((tag) => {
        return {
          label: tag.name,
          value: tag.id
        };
      });
    }

    return [];
  }, [tags]);

  return (
    <MultiSelect
      label="Tags"
      name={name}
      onChange={onChange}
      options={options}
      placeholder={`Add a tag`}
      selectedIcon={faTag}
      selectedOptions={value}
    />
  );
};

export default memo(TagSelector);
